/**
 * Maps the appointment availability returned from the API to a format that
 * can be used to display in the CalendarWidget component.
 * Slots are sorted by UTC start time so each day’s options stay chronological.
 * @param {Object} appointmentAvailability - The appointment availability.
 * @returns {Array} The slots.
 */
export const mapAppointmentAvailabilityToSlots = appointmentAvailability => {
  if (!appointmentAvailability?.availableSlots?.length) return [];
  const slots = appointmentAvailability.availableSlots.map(slot => ({
    start: slot.dtStartUtc,
    end: slot.dtEndUtc,
  }));
  return slots.sort((a, b) => new Date(a.start) - new Date(b.start));
};
